import { closeSnackbar } from 'notistack';
import { Stack, IconButton, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export const notistackDefaultAction = (snackbarId) => (
  <>
    <IconButton
      size="small"
      onClick={() => {
        closeSnackbar(snackbarId);
      }}
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  </>
);

export const notistackBinAction = ({ id, path }) => (
  <Stack
    direction="row"
    spacing={1}
  >
    <Button
      href={path}
      size="small"
      sx={{ mx: 2 }}
    >
      SHOW LOCATION
    </Button>
    <IconButton
      size="small"
      onClick={() => {
        closeSnackbar(id);
      }}
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  </Stack>
);
